import { initialState } from "../initialState";
import * as ManageLabourer from "./manageLabourerActions";

export const manageLabourerReducer = (state = initialState.contracts, action) => {
    switch (action.type) {
        case ManageLabourer.REQUEST_CONTRACTS_SUCCEEDED:
            return [...action.contracts];
        case ManageLabourer.REQUEST_CONTRACTS_FAILED:
            return [];
        default:
            return state;
    }
};

export const manageLabourerSkillsReducer = (state = initialState.skills, action) => {
    switch (action.type) {
        case ManageLabourer.REQUEST_SKILLS_SUCCEEDED:
            return [...action.skills];
        case ManageLabourer.REQUEST_SKILLS_FAILED:
            return [];
        default:
            return state;
    }
};
export const manageLabourerCreateTechnicianErrorReducer = (state = initialState.errors, action) => {
    switch (action.type) {
        case ManageLabourer.CREATE_TECHNICIAN_FAILED:
            return action.error;
        case ManageLabourer.UPDATE_TECHNICIAN_FAILED:
            return action.error;
        default:
            return state;
    }
};

export const setSelectedLabourerStatus = (state = initialState.isSelectedTechnicianEnabled, action) => {
    switch (action.type) {
        case ManageLabourer.SET_LABOURER_STATUS:
            return action.status;
        default:
            return state;
    }
};
